export const SWITCH_LANGUAGE = "SWITCH_LANGUAGE";

export const switchLanguage = (language) => {
  return { type: SWITCH_LANGUAGE, language };
};
